var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    fill: "none",
    viewBox: "0 0 30 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#28c445",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.884 10.016c-.52 0-1.04.346-1.04.867 0 .52.52.867 1.04.867s.867-.347.867-.867c0-.542-.347-.867-.867-.867m7.045 5.028c-.347 0-.672.369-.672.694 0 .369.347.694.672.694.52 0 .867-.347.867-.694s-.347-.694-.867-.694m-2.233-3.294c.52 0 .867-.369.867-.867 0-.52-.346-.867-.867-.867-.52 0-1.04.346-1.04.867 0 .52.52.867 1.04.867m6.005 3.294c-.347 0-.672.369-.672.694 0 .369.346.694.672.694.52 0 .867-.347.867-.694s-.347-.694-.867-.694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.957.086C6.698.086 0 6.784 0 15.043 0 23.3 6.698 29.999 14.957 29.999c8.258 0 14.956-6.698 14.956-14.956 0-8.26-6.698-14.957-14.956-14.957m-2.84 18.793c-.867 0-1.56-.173-2.384-.368l-2.385 1.214.672-2.103c-1.712-1.214-2.753-2.796-2.753-4.682 0-3.316 3.1-5.918 6.85-5.918 3.36 0 6.33 2.081 6.915 4.877a7 7 0 0 0-.65-.043c-3.252.043-5.81 2.493-5.81 5.528 0 .498.087.975.217 1.452a7 7 0 0 1-.672.043m10.145 2.428.52 1.734-1.864-1.04c-.672.173-1.366.346-2.06.346-3.273 0-5.852-2.254-5.852-5.05-.022-2.775 2.558-5.029 5.809-5.029 3.1 0 5.831 2.276 5.831 5.05 0 1.561-1.019 2.949-2.384 3.989"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeChat);
export default __webpack_public_path__ + "static/media/WeChat.bcebb2c58441756d71370bf6fdffb83c.svg";
export { ForwardRef as ReactComponent };